module.exports = __webpack_public_path__ + "img/clogo.ca9dc4cd.png";